// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://6aeb5d9d7903309c85fd6a881c6749ad@o4507646883594240.ingest.us.sentry.io/4507646894669824",

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,
  tracePropagationTargets: [
    /^\//,
    ...(process.env.NEXT_PUBLIC_BFF_BASE_URL
      ? [process.env.NEXT_PUBLIC_BFF_BASE_URL]
      : []),
  ],

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

// Export the router transition hook to instrument navigations
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
